module.exports = __webpack_public_path__ + "static/img/247_TO8_2211.53a81de.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/247_TO8_2211.jpg
// module id = NYs5
// module chunks = 0